jQuery(function () {
    loadHeader();
    loadCustomForms();
    loadPopups();
    loadChangeSign();
    loadSlideShow();
    loadRelatedProducts();
    loadTabs();
    loadAddToCardEvent();
    loadAddToCardWholesaleEvent();
    loadModifications();
    loadStarRating();
    loadRatingScroll();
    loadCheckout();

  // Import and use the lazy loader for non-critical modules
  import(/* webpackChunkName: "lazy-loader" */ '../modules/modulesLazyLoader')
    .then(({ default: lazyLoader }) => {
      lazyLoader([
        loadProductShare,
        loadLazyVideoLoader,
        loadMerchelloUi,
        // loadJqueryValidateUnobtrusive,
        loadAddReview,
        loadReviewPagination
      ]);
    })
    .catch(error => console.error('Error loading lazy loader module:', error));
})

const loadHeader = () => {
    import(/* webpackChunkName: "header" */ '../modules/header/index')
      .then(({ default: header }) => {
          header();
      })
      .catch(error => console.error('Error loading header module:', error));
};

const loadCheckout = () => {
    import(/* webpackChunkName: "checkout" */ '../modules/checkoutModule')
      .then(({ default: checkout }) => {
          checkout();
      })
      .catch(error => console.error('Error loading checkout module:', error));
};

const loadCustomForms = () => {
    import(/* webpackChunkName: "custom-forms" */ '../modules/initCustomForms')
      .then(({ default: initCustomForms }) => {
          initCustomForms();
      })
      .catch(error => console.error('Error loading custom forms module:', error));
};

const loadPopups = () => {
    import(/* webpackChunkName: "popups" */ '../modules/initPopups')
      .then(({ default: initPopups }) => {
          initPopups();
      })
      .catch(error => console.error('Error loading popups module:', error));
};

const loadChangeSign = () => {
    import(/* webpackChunkName: "change-sign" */ '../modules/changeSign')
      .then(({ default: changeSign }) => {
          changeSign();
      })
      .catch(error => console.error('Error loading change sign module:', error));
};

const loadSlideShow = () => {
    import(/* webpackChunkName: "slide-show" */ '../modules/initSlideShow')
      .then(({ default: initSlideShow }) => {
          initSlideShow();
      })
      .catch(error => console.error('Error loading slide show module:', error));
};

const loadMerchelloUi = () => {
    import(/* webpackChunkName: "merchello-ui" */ '../libraries/merchello.ui')
      .then(({ default: merchelloUi }) => {
          merchelloUi();
      })
      .catch(error => console.error('Error loading merchello UI module:', error));
};

const loadJqueryValidateUnobtrusive = () => {
    import(/* webpackChunkName: "jquery-validate" */ '../libraries/jquery.validate.unobtrusive.min')
      .then(({ default: jqueryValidateUnobtrusive }) => {
          jqueryValidateUnobtrusive();
      })
      .catch(error => console.error('Error loading jquery validate module:', error));
};

const loadProductShare = () => {
    import(/* webpackChunkName: "product-share" */ '../modules/productShare')
      .then(({ default: productShare }) => {
          productShare();
      })
      .catch(error => console.error('Error loading product share module:', error));
};

const loadRelatedProducts = () => {
    import(/* webpackChunkName: "related-products" */ '../modules/productCarousel')
      .then(({ default: relatedProducts }) => {
          relatedProducts();
      })
      .catch(error => console.error('Error loading related products module:', error));
};

const loadTabs = () => {
    import(/* webpackChunkName: "tabs" */ '../modules/initTabs')
      .then(({ default: initTabs }) => {
          initTabs();
      })
      .catch(error => console.error('Error loading tabs module:', error));
};

const loadAddToCardEvent = () => {
    import(/* webpackChunkName: "add-to-card" */ '../modules/addToCardEvent')
      .then(({ default: addToCardEventInit }) => {
          addToCardEventInit();
      })
      .catch(error => console.error('Error loading add to card event module:', error));
};

const loadAddToCardWholesaleEvent = () => {
    import(/* webpackChunkName: "add-to-card-wholesale" */ '../modules/addToCardWholesaleEvent')
      .then(({ default: addToCardWholesaleEventInit }) => {
          addToCardWholesaleEventInit();
      })
      .catch(error => console.error('Error loading add to card wholesale event module:', error));
};

const loadModifications = () => {
    import(/* webpackChunkName: "modifications" */ '../modules/initModifications')
      .then(({ default: initModifications }) => {
          initModifications();
      })
      .catch(error => console.error('Error loading modifications module:', error));
};

const loadStarRating = () => {
    import(/* webpackChunkName: "star-rating" */ '../modules/starRating')
      .then(({ default: starRating }) => {
          starRating();
      })
      .catch(error => console.error('Error loading star rating module:', error));
};

const loadRatingScroll = () => {
    import(/* webpackChunkName: "rating-scroll" */ '../modules/initRatingScroll')
      .then(({ default: initRatingScroll }) => {
          initRatingScroll();
      })
      .catch(error => console.error('Error loading rating scroll module:', error));
};

const loadAddReview = () => {
    import(/* webpackChunkName: "add-review" */ '../modules/addReview')
      .then(({ default: addReview }) => {
          addReview();
      })
      .catch(error => console.error('Error loading add review module:', error));
};

const loadReviewPagination = () => {
    import(/* webpackChunkName: "review-pagination" */ '../modules/reviewPagination')
      .then(({ default: reviewPagination }) => {
          reviewPagination();
      })
      .catch(error => console.error('Error loading review pagination module:', error));
};

const loadLazyVideoLoader = () => {
    import(/* webpackChunkName: "lazy-video-loader" */ '../modules/lazyVideoLoader')
      .then(({ default: initLazyVideoLoader }) => {
          initLazyVideoLoader();
      })
      .catch(error => console.error('Error loading lazy video loader module:', error));
};
